
import { Component, Inject, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { NgxHekaDesignLibModule } from 'ngx-heka-design-lib';

@Component({
  selector: 'app-multi-domain-last-admin-error-dialog',
  imports: [NgxHekaDesignLibModule, MatButtonModule, MatDialogModule, TranslateModule],
  templateUrl: './multi-domain-last-admin-error-dialog.component.html',
  standalone: true,
  styleUrl: './multi-domain-last-admin-error-dialog.component.scss'
})
export class MultiDomainLastAdminErrorDialogComponent {
  @Input() companyName: string;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { companyName: string }
  ) {
    this.companyName = data?.companyName;
  }
}
